import { render, staticRenderFns } from "./member_item.vue?vue&type=template&id=70f90a5a&scoped=true"
import script from "./member_item.vue?vue&type=script&lang=js"
export * from "./member_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f90a5a",
  null
  
)

export default component.exports